import React, { useMemo, useState } from 'react';
import SettingsHeader from 'pages/authenticated/layout/settingsLayout/settingsHeader/SettingsHeader';
import styles from './LinkToAgent.module.scss';
import NewConnection from 'component/organism/settings-linkTo-agent/new-connection/NewConnection';
import { useParams } from 'react-router-dom';
import { Agent } from 'hooks/endpoints';
import { useFetch } from 'hooks/useFetch';
import AgentCard from 'component/organism/settings-linkTo-agent/agent-card/AgentCard';
import SearchInput from 'component/atom/forms/input/searchInput/SearchInput';
import Loader from 'component/atom/loader/Loader';
import NoData from 'component/molecules/Table/TableComponents/NoData/NoData';

const LinkToAgent = () => {
  const { id } = useParams();
  const [isAdd, setIsAdd] = useState(false);
  const [query, setQuery] = useState('');
  const [agentItem, setAgentItem] = useState(null);

  const { data, refetch, isFetching } = useFetch(
    ['agents', id],
    Agent.getAllAgents(id),
    {
      enabled: !!id,
    }
  );
  const agents = data?.data ?? [];

  const handleCloseModal = () => {
    setIsAdd(false);
  };

  const headerActions = [
    {
      label: 'New Connection',
      type: 'plus',
      opicBackground: true,
      func: () => setIsAdd(true),
    },
  ];
  const handleSearchChange = (_name, value) => {
    setQuery(value);
  };
  const filteredAgents = useMemo(() => {
    if (!query?.trim()) return agents;
    const q = query.trim().toLowerCase();

    const toStr = (v) => (v == null ? '' : String(v)).toLowerCase();

    return agents.filter(
      (a) =>
        toStr(a.agentName).includes(q) ||
        toStr(a.connectionName).includes(q) ||
        toStr(a.baseURL).includes(q) ||
        toStr(a.application).includes(q) ||
        toStr(a.id).includes(q)
    );
  }, [agents, query]);
  const isEmpty = !isFetching && agents.length === 0;
  const noMatches =
    !isFetching && agents.length > 0 && filteredAgents.length === 0;

  return (
    <div className={`${styles['link-to-agent-container']} agent-container`}>
      <SettingsHeader
        title='Systems Integrations'
        rightButtons={headerActions}
      />
      <div className={styles['integrations-container']}>
        {agents.length > 0 && (
          <SearchInput
            classname={styles['search']}
            onChange={handleSearchChange}
            placeholder='Search'
            value={query}
          />
        )}
        {isFetching ? (
          <Loader classname={styles['empty-state']} />
        ) : isEmpty ? (
          <div className={styles['empty-state']}>
            <NoData type='noSystem' text='No System Found' />
          </div>
        ) : noMatches ? (
          <div className={styles['empty-state']}>
            <NoData type='noSystem' text='No System Found' />
          </div>
        ) : (
          <div className={styles['integrations-wrapper']}>
            {filteredAgents.map((item) => (
              <AgentCard key={item?.id} item={item} refetch={refetch} />
            ))}
          </div>
        )}
      </div>
      <NewConnection
        isOpen={isAdd}
        onClose={handleCloseModal}
        botId={id}
        refetch={refetch}
        agentItem={agentItem}
        setAgentItem={setAgentItem}
      />
    </div>
  );
};

export default LinkToAgent;
